import { Capacitor } from '@capacitor/core';

let topMargin = 0;

window.addEventListener('load', () => {
  topMargin = getComputedStyle(document.documentElement).getPropertyValue('--sat');
});

export function isApp() {
  return Capacitor.getPlatform() !== 'web';
}

export function getTopMargin() {
  return Number(`${topMargin}`.replace('px', ''));
}
